import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { BaseDialog, FileUploadInput, LoadingFeedback } from 'components'
import { Box, TextField, Typography } from '@material-ui/core'
import { Controller, FormContext, useForm } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'
import constants from 'constants/index'
import schema from './schema'
import theme from 'theme'

// O service vem por prop (service.dponet.privacyByDesign ou
// service.guestPortal.privacyByDesign) para o mesmo diálogo atender ao app e ao
// portal de convidados.
const RiskAssumedDialog = ({
  open,
  setOpen,
  privacyByDesignId,
  service,
  refresh = () => {},
  redirectToList = () => {},
}) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()
  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      content: '',
      attachments: [],
    },
  })

  const { RISK_ASSUMED_STATUS_LABEL } = constants.privacyByDesign

  const { control, errors, handleSubmit } = formMethods

  const handleClose = () => setOpen(false)

  const handleRiskAssumed = async (data) => {
    try {
      setLoading(true)

      await service.changeStatus({
        privacyByDesignId,
        status: RISK_ASSUMED_STATUS_LABEL,
        ...data,
      })

      snackbar.open({
        message: 'Risco assumido com sucesso.',
        variant: 'success',
      })

      handleClose()
      refresh()
      redirectToList()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao tentar assumir risco. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <BaseDialog
        open={open}
        setOpen={setOpen}
        title="Você tem certeza que deseja assumir o risco?"
        closeButtonText="Voltar"
        actionButton={handleSubmit(handleRiskAssumed)}
        actionButtonText="Assumir Risco"
        dialogSize="md"
        justifyActions="flex-end"
        fullWidth
        noPadding
      >
        <Box
          p={2}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(1)}
        >
          <Typography variant="subtitle1">
            Apesar da reprovação no Privacy by Design, a organização opta por
            assumir o risco de forma consciente, estando ciente dos impactos e
            das responsabilidades envolvidas.
          </Typography>
          <FormContext {...formMethods}>
            <Controller
              control={control}
              name="content"
              as={
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  maxRows={5}
                  placeholder="Justificativa"
                  error={!!errors?.content}
                  helperText={errors?.content?.message}
                />
              }
            />
            <Controller
              control={control}
              name="attachments"
              as={
                <FileUploadInput
                  controlName="attachments"
                  maxSize={constants.validations.MAX_FILE_SIZE_15_MB}
                  hasDownloadFile
                  controllerBar
                  multiple
                />
              }
            />
          </FormContext>
        </Box>
      </BaseDialog>
    </>
  )
}

RiskAssumedDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  privacyByDesignId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  service: PropTypes.object,
  refresh: PropTypes.func,
  redirectToList: PropTypes.func,
}

export default RiskAssumedDialog
